import { toast } from 'react-hot-toast';

// Utility function to show connection error toast only once
let hasShownConnectionError = false;

export const showConnectionErrorToast = () => {
  if (!hasShownConnectionError) {
    hasShownConnectionError = true;
    toast.error('Lost connection to server. Please refresh the page.', {
      id: 'connection-error', // Unique ID prevents duplicates
      duration: 8000,
      position: 'top-center',
      style: {
        background: '#fee2e2',
        color: '#dc2626',
        border: '2px solid #fca5a5',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: '600',
        padding: '16px 20px',
        maxWidth: '400px',
        textAlign: 'center',
      },
    });
  }
};

export const clearConnectionErrorToast = () => {
  hasShownConnectionError = false;
  toast.dismiss('connection-error');
};

// Extract error message from various error formats
export const formatErrorMessage = (error) => {
  if (typeof error === 'string') {
    return error;
  }
  
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  
  if (error?.response?.data?.detail) {
    return error.response.data.detail;
  }
  
  if (error?.response?.data?.error) {
    return error.response.data.error;
  }
  
  if (error?.message) {
    return error.message;
  }
  
  return 'An unexpected error occurred';
};

// Show field validation errors in a toast
export const showFieldErrors = (errors) => {
  if (typeof errors === 'object' && errors !== null) {
    const errorMessages = Object.entries(errors)
      .map(([field, messages]) => {
        const fieldName = field.charAt(0).toUpperCase() + field.slice(1);
        const messageList = Array.isArray(messages) ? messages : [messages];
        return `${fieldName}: ${messageList.join(', ')}`;
      })
      .join('\n');
    
    toast.error(errorMessages, {
      duration: 6000,
      style: {
        whiteSpace: 'pre-line',
      },
    });
  }
}; 